module.exports = __webpack_public_path__ + "static/media/5_r_vili_90.47_51.76.0573193b.png";